/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /api/v1/autocomplete(.:format) */
export function apiV1AutocompletePath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "autocomplete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/autocomplete/profiles(.:format) */
export function apiV1AutocompleteProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "autocomplete" + "/" + "profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/autocomplete/organizations(.:format) */
export function apiV1AutocompleteOrganizationsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "autocomplete" + "/" + "organizations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/profiles/:id/export_pdf(.:format) */
export function exportPdfApiV1ProfilePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "profiles" + "/" + id + "/" + "export_pdf" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/profiles/export_search(.:format) */
export function exportSearchApiV1ProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "profiles" + "/" + "export_search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/profiles/:profile_id/requests(.:format) */
export function apiV1ProfileRequestsPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "profiles" + "/" + profile_id + "/" + "requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/profiles(.:format) */
export function apiV1ProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/profiles/:id(.:format) */
export function apiV1ProfilePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "profiles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/organizations/:id/export_pdf(.:format) */
export function exportPdfApiV1OrganizationPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + "/" + id + "/" + "export_pdf" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/organizations/:organization_id/workers(.:format) */
export function apiV1OrganizationWorkersPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + "/" + organization_id + "/" + "workers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/organizations/:organization_id/requests(.:format) */
export function apiV1OrganizationRequestsPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + "/" + organization_id + "/" + "requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/organizations(.:format) */
export function apiV1OrganizationsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/organizations/:id(.:format) */
export function apiV1OrganizationPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/regions(.:format) */
export function apiV1RegionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "regions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/business_functions(.:format) */
export function apiV1BusinessFunctionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "business_functions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/industries(.:format) */
export function apiV1IndustriesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/organizations/filter_options(.:format) */
export function apiV1OrganizationFilterOptionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "organizations" + "/" + "filter_options" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/interests(.:format) */
export function apiV1InterestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "interests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/sessions(.:format) */
export function apiV1SessionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "sessions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/password_reset(.:format) */
export function apiV1PasswordResetPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "password_reset" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/requests/bulk_preview(.:format) */
export function bulkPreviewApiV1RequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "requests" + "/" + "bulk_preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/requests/bulk_commit(.:format) */
export function bulkCommitApiV1RequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "requests" + "/" + "bulk_commit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/requests/profile_match(.:format) */
export function profileMatchApiV1RequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "requests" + "/" + "profile_match" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/requests(.:format) */
export function apiV1RequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/requests/:id(.:format) */
export function apiV1RequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/tracked_subjects/:id/duplicate(.:format) */
export function duplicateApiV1TrackedSubjectPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + id + "/" + "duplicate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/tracked_subjects/subject_change_event_groups(.:format) */
export function subjectChangeEventGroupsApiV1TrackedSubjectsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + "subject_change_event_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tracked_subjects/subject_change_event_groups/mark_subject_read(.:format) */
export function subjectChangeEventGroupsMarkSubjectReadApiV1TrackedSubjectsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + "subject_change_event_groups" + "/" + "mark_subject_read" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tracked_subjects/subject_change_events(.:format) */
export function subjectChangeEventsApiV1TrackedSubjectsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + "subject_change_events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tracked_subjects/subject_change_events/mark_all_read(.:format) */
export function subjectChangeEventsMarkAllReadApiV1TrackedSubjectsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + "subject_change_events" + "/" + "mark_all_read" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tracked_subjects/:tracked_subject_id/subject_change_event_groups/mark_subject_read(.:format) */
export function markSubjectReadApiV1TrackedSubjectSubjectChangeEventGroupsPath(tracked_subject_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + tracked_subject_id + "/" + "subject_change_event_groups" + "/" + "mark_subject_read" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tracked_subject_id","format"]);
}

/** /api/v1/tracked_subjects/:tracked_subject_id/subject_change_event_groups(.:format) */
export function apiV1TrackedSubjectSubjectChangeEventGroupsPath(tracked_subject_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + tracked_subject_id + "/" + "subject_change_event_groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tracked_subject_id","format"]);
}

/** /api/v1/tracked_subjects/:tracked_subject_id/subject_change_events/mark_all_read(.:format) */
export function markAllReadApiV1TrackedSubjectSubjectChangeEventsPath(tracked_subject_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + tracked_subject_id + "/" + "subject_change_events" + "/" + "mark_all_read" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tracked_subject_id","format"]);
}

/** /api/v1/tracked_subjects/:tracked_subject_id/subject_change_events(.:format) */
export function apiV1TrackedSubjectSubjectChangeEventsPath(tracked_subject_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + tracked_subject_id + "/" + "subject_change_events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tracked_subject_id","format"]);
}

/** /api/v1/tracked_subjects/:tracked_subject_id/subject_change_events/:id(.:format) */
export function apiV1TrackedSubjectSubjectChangeEventPath(tracked_subject_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + tracked_subject_id + "/" + "subject_change_events" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tracked_subject_id","id","format"]);
}

/** /api/v1/tracked_subjects(.:format) */
export function apiV1TrackedSubjectsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/tracked_subjects/:id(.:format) */
export function apiV1TrackedSubjectPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "tracked_subjects" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/subscriptions/summary(.:format) */
export function apiV1SubscriptionsSummaryPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "subscriptions" + "/" + "summary" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/relationship_mapping(.:format) */
export function apiV1RelationshipMappingPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "relationship_mapping" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/relationship_mapping/details(.:format) */
export function apiV1RelationshipMappingDetailsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "relationship_mapping" + "/" + "details" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/relationship_mapping/export_details_pdf(.:format) */
export function apiV1RelationshipMappingExportDetailsPdfPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "relationship_mapping" + "/" + "export_details_pdf" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/relationship_mapping/paths(.:format) */
export function apiV1RelationshipMappingPathsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "relationship_mapping" + "/" + "paths" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/elasticsearch/reindex_all(.:format) */
export function apiV1AdminElasticsearchReindexAllPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "elasticsearch" + "/" + "reindex_all" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/elasticsearch/reindex_profiles(.:format) */
export function apiV1AdminElasticsearchReindexProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "elasticsearch" + "/" + "reindex_profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/elasticsearch/reindex_organizations(.:format) */
export function apiV1AdminElasticsearchReindexOrganizationsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "elasticsearch" + "/" + "reindex_organizations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/pathfinder/rebuild_neighbors(.:format) */
export function apiV1AdminPathfinderRebuildNeighborsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "pathfinder" + "/" + "rebuild_neighbors" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/accounts/:account_id/credit_transactions(.:format) */
export function apiV1AdminAccountCreditTransactionsPath(account_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "accounts" + "/" + account_id + "/" + "credit_transactions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account_id","format"]);
}

/** /api/v1/admin/accounts(.:format) */
export function apiV1AdminAccountsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "accounts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/accounts/new(.:format) */
export function newApiV1AdminAccountPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "accounts" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/accounts/:id/edit(.:format) */
export function editApiV1AdminAccountPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "accounts" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/accounts/:id(.:format) */
export function apiV1AdminAccountPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "accounts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/business_functions(.:format) */
export function apiV1AdminBusinessFunctionsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "business_functions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/business_functions/new(.:format) */
export function newApiV1AdminBusinessFunctionPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "business_functions" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/business_functions/:id/edit(.:format) */
export function editApiV1AdminBusinessFunctionPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "business_functions" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/business_functions/:id(.:format) */
export function apiV1AdminBusinessFunctionPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "business_functions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/dashboards/request_summaries(.:format) */
export function apiV1AdminDashboardsRequestSummariesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "dashboards" + "/" + "request_summaries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/dashboards/value_metrics(.:format) */
export function apiV1AdminDashboardsValueMetricsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "dashboards" + "/" + "value_metrics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/industries(.:format) */
export function apiV1AdminIndustriesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/industries/new(.:format) */
export function newApiV1AdminIndustryPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "industries" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/industries/:id/edit(.:format) */
export function editApiV1AdminIndustryPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "industries" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/industries/:id(.:format) */
export function apiV1AdminIndustryPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "industries" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/interests/:id/merge(.:format) */
export function mergeApiV1AdminInterestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interests" + "/" + id + "/" + "merge" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/interests(.:format) */
export function apiV1AdminInterestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/interests/new(.:format) */
export function newApiV1AdminInterestPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interests" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/interests/:id/edit(.:format) */
export function editApiV1AdminInterestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interests" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/interests/:id(.:format) */
export function apiV1AdminInterestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "interests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/quartr_event_transcripts/sync(.:format) */
export function syncApiV1AdminQuartrEventTranscriptsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "quartr_event_transcripts" + "/" + "sync" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/quartr_event_transcripts(.:format) */
export function apiV1AdminQuartrEventTranscriptsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "quartr_event_transcripts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/quartr_event_transcripts/:id(.:format) */
export function apiV1AdminQuartrEventTranscriptPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "quartr_event_transcripts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/organizations/:id/merge(.:format) */
export function mergeApiV1AdminOrganizationPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + id + "/" + "merge" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/organizations/:organization_id/versions(.:format) */
export function apiV1AdminOrganizationVersionsPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + organization_id + "/" + "versions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/admin/organizations/:organization_id/draft_version/logo(.:format) */
export function logoApiV1AdminOrganizationDraftVersionPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + organization_id + "/" + "draft_version" + "/" + "logo" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/admin/organizations/:organization_id/draft_version/publish(.:format) */
export function publishApiV1AdminOrganizationDraftVersionPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + organization_id + "/" + "draft_version" + "/" + "publish" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/admin/organizations/:organization_id/draft_version(.:format) */
export function apiV1AdminOrganizationDraftVersionPath(organization_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + organization_id + "/" + "draft_version" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["organization_id","format"]);
}

/** /api/v1/admin/organizations(.:format) */
export function apiV1AdminOrganizationsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/organizations/:id(.:format) */
export function apiV1AdminOrganizationPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "organizations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/profiles/search(.:format) */
export function searchApiV1AdminProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + "search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/profiles/:profile_id/versions(.:format) */
export function apiV1AdminProfileVersionsPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "versions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/avatar(.:format) */
export function avatarApiV1AdminProfileDraftVersionPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "avatar" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/publish(.:format) */
export function publishApiV1AdminProfileDraftVersionPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "publish" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/validate(.:format) */
export function validateApiV1AdminProfileDraftVersionPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "validate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/boards/:id/reorder(.:format) */
export function reorderApiV1AdminProfileDraftVersionBoardPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "boards" + "/" + id + "/" + "reorder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/boards(.:format) */
export function apiV1AdminProfileDraftVersionBoardsPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "boards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/boards/:id(.:format) */
export function apiV1AdminProfileDraftVersionBoardPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "boards" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/institutions/:id/reorder(.:format) */
export function reorderApiV1AdminProfileDraftVersionInstitutionPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "institutions" + "/" + id + "/" + "reorder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/institutions(.:format) */
export function apiV1AdminProfileDraftVersionInstitutionsPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "institutions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/institutions/:id(.:format) */
export function apiV1AdminProfileDraftVersionInstitutionPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "institutions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/interests(.:format) */
export function apiV1AdminProfileDraftVersionInterestsPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "interests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/interests/:id(.:format) */
export function apiV1AdminProfileDraftVersionInterestPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "interests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/priorities/:id/reorder(.:format) */
export function reorderApiV1AdminProfileDraftVersionPriorityPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "priorities" + "/" + id + "/" + "reorder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/priorities(.:format) */
export function apiV1AdminProfileDraftVersionPrioritiesPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "priorities" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/priorities/:id(.:format) */
export function apiV1AdminProfileDraftVersionPriorityPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "priorities" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/works/:id/reorder(.:format) */
export function reorderApiV1AdminProfileDraftVersionWorkPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "works" + "/" + id + "/" + "reorder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/works(.:format) */
export function apiV1AdminProfileDraftVersionWorksPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "works" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version/works/:id(.:format) */
export function apiV1AdminProfileDraftVersionWorkPath(profile_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + "/" + "works" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","id","format"]);
}

/** /api/v1/admin/profiles/:profile_id/draft_version(.:format) */
export function apiV1AdminProfileDraftVersionPath(profile_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + profile_id + "/" + "draft_version" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["profile_id","format"]);
}

/** /api/v1/admin/profiles(.:format) */
export function apiV1AdminProfilesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/profiles/:id(.:format) */
export function apiV1AdminProfilePath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "profiles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/users/:id/reset_password(.:format) */
export function resetPasswordApiV1AdminUserPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + id + "/" + "reset_password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/users/:user_id/credit_transactions(.:format) */
export function apiV1AdminUserCreditTransactionsPath(user_id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + user_id + "/" + "credit_transactions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["user_id","format"]);
}

/** /api/v1/admin/users(.:format) */
export function apiV1AdminUsersPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/users/new(.:format) */
export function newApiV1AdminUserPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/users/:id/edit(.:format) */
export function editApiV1AdminUserPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/users/:id(.:format) */
export function apiV1AdminUserPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/bulk_assign(.:format) */
export function bulkAssignApiV1AdminRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + "bulk_assign" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/requests/bulk_preview(.:format) */
export function bulkPreviewApiV1AdminRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + "bulk_preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/requests/bulk_commit(.:format) */
export function bulkCommitApiV1AdminRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + "bulk_commit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/requests/profile_match(.:format) */
export function profileMatchApiV1AdminRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + "profile_match" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/requests/:id/start_ai(.:format) */
export function startAiApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "start_ai" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/complete_ai(.:format) */
export function completeAiApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "complete_ai" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/skip_ai(.:format) */
export function skipAiApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "skip_ai" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/fail_ai(.:format) */
export function failAiApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "fail_ai" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/start_editor(.:format) */
export function startEditorApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "start_editor" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/complete_editor(.:format) */
export function completeEditorApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "complete_editor" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/start_admin(.:format) */
export function startAdminApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "start_admin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/approve(.:format) */
export function approveApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "approve" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/reject(.:format) */
export function rejectApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "reject" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/cancel(.:format) */
export function cancelApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "cancel" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/deliver_directly(.:format) */
export function deliverDirectlyApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "deliver_directly" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests/:id/assign(.:format) */
export function assignApiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + "/" + "assign" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/requests(.:format) */
export function apiV1AdminRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/requests/:id(.:format) */
export function apiV1AdminRequestPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/evaluation_runs(.:format) */
export function apiV1AdminEvaluationRunsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "evaluation_runs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/evaluation_runs/:id(.:format) */
export function apiV1AdminEvaluationRunPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "evaluation_runs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/admin/evaluation_metrics(.:format) */
export function apiV1AdminEvaluationMetricsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "evaluation_metrics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/admin/evaluation_metrics/:id(.:format) */
export function apiV1AdminEvaluationMetricPath(id: ScalarType, options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "admin" + "/" + "evaluation_metrics" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /api/v1/current_user/register(.:format) */
export function registerApiV1CurrentUserPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + "/" + "register" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/current_user(.:format) */
export function apiV1CurrentUserPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "current_user" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/failure(.:format) */
export function authFailurePath(options?: object): string {
  return "/" + "auth" + "/" + "failure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** / */
export function rootPath(options?: object): string {
  return "/" + $buildOptions(options, []);
}

/** /docs */
export function oasRailsPath(options?: object): string {
  return "/" + "docs" + $buildOptions(options, []);
}

/** /letter_opener */
export function letterOpenerWebPath(options?: object): string {
  return "/" + "letter_opener" + $buildOptions(options, []);
}

/** /letter_opener/ */
export function letterOpenerWebLettersPath(options?: object): string {
  return "/" + "letter_opener" + "/" + $buildOptions(options, []);
}

/** /letter_opener/clear(.:format) */
export function letterOpenerWebClearLettersPath(options?: object): string {
  return "/" + "letter_opener" + "/" + "clear" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /letter_opener/:id(/:style)(.:format) */
export function letterOpenerWebLetterPath(id: ScalarType, options?: object): string {
  return "/" + "letter_opener" + "/" + id + ($hasPresentOwnProperty(options, "style") ? "/" + (options as any).style : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","style","format"]);
}

/** /letter_opener/:id/delete(.:format) */
export function letterOpenerWebDeleteLetterPath(id: ScalarType, options?: object): string {
  return "/" + "letter_opener" + "/" + id + "/" + "delete" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}
